import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, map, switchMap, tap } from 'rxjs/operators';

import { AppSessionService } from '../session/app-session.service';

import { CityLoginResponse, LoginRequest } from '../models/login.model';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LogoutRequestBody } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class AppAuthService {
  appSessionService = inject(AppSessionService);
  // authenticateModel: AuthenticateModel | undefined;
  // authenticateResult?: AuthenticateResultModel | undefined;
  // rememberMe = false;
  //
  // appInitializerService = inject(AppInitializer);
  // appSessionService = inject(AppSessionService);
  // permissionService = inject(AbpPermissionCheckerService);
  readonly httpClient = inject(HttpClient);
  //
  // private _router = inject(Router);
  //
  // constructor(
  //     private _tokenAuthService: TokenAuthServiceProxy,
  //     private _utilsService: AbpUtilsService,
  //     private _tokenService: AbpTokenService
  //     // private _logService: LogService
  // ) {
  //     this.clear();
  // }
  //
  logout(body: LogoutRequestBody): Observable<void> {
    return this.httpClient.post<void>(`${environment.urlBackend}/api/auth/logout`, body).pipe(
      tap(() => {
        this.appSessionService.setData(undefined);
      }),
    );
  }

  login(authModel: LoginRequest, finallyCallback?: () => void): Observable<CityLoginResponse> {
    return this.httpClient.post<CityLoginResponse>(`${environment.urlBackend}/api/auth/login`, authModel).pipe(
      tap((response: CityLoginResponse) => {
        this.appSessionService.setData(response);
      }),
      finalize(() => {
        finallyCallback?.();
      }),
      catchError((error: Error) => {
        this.appSessionService.setData(undefined);
        throw error;
      })
    )
  }

  refreshToken(): Observable<CityLoginResponse> {
    return this.httpClient.post<CityLoginResponse>(`${environment.urlBackend}/api/auth/refresh`, { refreshToken: this.appSessionService.refreshToken }).pipe(
      tap((response: CityLoginResponse) => {
        this.appSessionService.setData(response);
      }),
      catchError((error: Error) => {
        throw error;
      })
    )
  }

  hasRole(role: 'Admin' | 'Compilatore'): boolean {
    const roles = this.appSessionService.userInfo?.roles || [];
    return roles.includes(role);
  }

  isAdmin(): boolean {
    return this.hasRole('Admin');
  }

  isCompilatore(): boolean {
    return this.hasRole('Compilatore');
  }

  getCurrentUserRoles(): string[] {
    return this.appSessionService.userInfo?.roles || [];
  }

  //
  //
  // authenticate(finallyCallback?: () => void): void {
  //     finallyCallback = finallyCallback || (() => {});
  //
  //     this._tokenAuthService
  //         .authenticate(this.authenticateModel)
  //         .pipe(
  //             tap((res) => {
  //                 this.processAuthenticateResult(res);
  //                 this.appSessionService.init();
  //             }),
  //             switchMap((res) => {
  //                 // Questa reload serve per caricare i permessi dell'utente collegato, deve reinizializzare tutta l'app
  //                 return this.appInitializerService.getUserConfigurationReload().pipe(
  //                     map(() => {
  //                         return res;
  //                     })
  //                 );
  //             }),
  //             switchMap((res) => {
  //                 return this.appSessionService.init().pipe(
  //                     map((loaded) => {
  //                         return res;
  //                     })
  //                 );
  //             }),
  //
  //             finalize(() => {
  //                 finallyCallback();
  //             })
  //         )
  //         .subscribe((result: AuthenticateResultModel) => {
  //             this.processAuthenticateResult(result);
  //         });
  // }
  //
  // private processAuthenticateResult(authenticateResult: AuthenticateResultModel) {
  //     this.authenticateResult = authenticateResult;
  //
  //     if (authenticateResult.accessToken) {
  //         // Successfully logged in
  //         this.login(authenticateResult.accessToken, authenticateResult.encryptedAccessToken!, authenticateResult.expireInSeconds, this.rememberMe);
  //     } else {
  //         // Unexpected result!
  //
  //         // this._logService.warn('Unexpected authenticateResult!');
  //         void this._router.navigate(['account/login']);
  //     }
  // }
  //
  // private login(accessToken: string, encryptedAccessToken: string, expireInSeconds: number, rememberMe?: boolean): void {
  //     const tokenExpireDate = rememberMe ? new Date(new Date().getTime() + 1000 * expireInSeconds) : undefined;
  //
  //     this._tokenService.setToken(accessToken, tokenExpireDate);
  //     console.log('login', AppConsts.appBaseUrl);
  //     this._utilsService.setCookieValue(
  //         AppConsts.authorization.encryptedAuthTokenName,
  //         encryptedAccessToken,
  //         tokenExpireDate
  //         // abp.appPath
  //     );
  //
  //     void this._router.navigate(['/home']); // TODO: check this
  //     //void this._router.navigate([AppConsts.appBaseUrl, 'home']);
  //     // TODO: check this
  //     // let initialUrl = UrlHelper.initialUrl;
  //     // if (initialUrl.indexOf('/login') > 0) {
  //     //     initialUrl = AppConsts.appBaseUrl;
  //     // }
  //     //
  //     // location.href = initialUrl;
  // }
  //
  // private clear(): void {
  //     this.authenticateModel = new AuthenticateModel();
  //     this.authenticateModel.rememberClient = false;
  //     // @ts-ignore
  //     this.authenticateResult = null;
  //     this.rememberMe = false;
  // }
}
